import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  ElementRef,
  OnDestroy,
  inject,
  signal,
  effect,
} from '@angular/core';
import { NgControl } from '@angular/forms';

import { focusElement } from '@plugins/client/utils';

import { FormService } from '../form.service';

@Component({
  selector: 'plugins-form-control',
  standalone: true,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormControlComponent implements OnInit, OnDestroy {
  @ViewChild('inputRef', { static: true }) inputRef?: ElementRef<HTMLElement>;

  @Input() set inputId(val: string) {
    this.#inputId.set(val);
  }

  get inputId() {
    return this.#inputId();
  }

  readonly #inputId = signal(`id-${Math.random().toString(16).slice(2)}`);
  // eslint-disable-next-line no-unused-private-class-members
  readonly #updateInputIdEffect = effect(() => {
    this.inputRef?.nativeElement.setAttribute('id', this.#inputId());
  });
  controlDirective = inject(NgControl, {
    self: true,
    optional: true,
  });
  protected formService = inject(FormService, { optional: true });

  ngOnInit(): void {
    this.formService?.addValidator(this.inputId, this.validate.bind(this));
  }

  validate(focus: boolean) {
    if (this.controlDirective?.valid ?? true) {
      return true;
    }
    if (focus) {
      this.focus();
    }
    return false;
  }

  focus() {
    focusElement(this.inputRef?.nativeElement);
  }

  ngOnDestroy(): void {
    this.formService?.removeValidator(this.inputId);
  }
}
